import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Accordion, AccordionSummary, AccordionDetails, } from "@material-ui/core";
import * as moment from "moment";
import { pdf } from "@react-pdf/renderer";
import { saveAs } from "file-saver";
import PdfDocument from "./BOLPdfDocument";
import { paymentMethod } from "redux/actions/payment";
import OnHoldModal from "web/components/OnHoldModal";
import CurrencyFormat from "react-currency-format";
import AlertModal from "web/components/AlertModal";
import { stateConvert, } from "web/components/utils/stateAbbreviation";
import styled from 'styled-components'
import Rating from '@material-ui/lab/Rating';
import ClaimRaisePopup from "../ClaimRaisePopup";
import { FORMAT } from "web/components/utils/dateOfBirthValidation";
import TrackDetailTypeOne from "./TrackDetailTypeOne";
import TrackDetailTypeTwo from "./TrackDetailTypeTwo";
import TrackDetailTypeCancel from "./TrackDetailTypeCancel";
import CancelOrderPopup from "../CancelOrderPopup";
import BolUploadModal from "web/components/BolUploadModal";

import TrackDetailTypeDelivered from "./TrackDetailTypeDelivered";
import Tooltip from "@material-ui/core/Tooltip";

import RightArrow from "web/assets/images/right-arrow-dark-blue.webp";
import RightArrowLight from "web/assets/images/right-arrow-sell.png";
import PromoAppliedTick from "web/assets/svg/PromoAppliedTick";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

import EditIcon from "web/assets/images/edit-icon.png";
import infoicon from "web/assets/images/info-icon.png";
import { updatePoNumber, updateReferenceNumber, updateBOL, getHoldOrdersList, downloadCreditMemoApiCall, downloadCancelReceiptApi, downloadRebateReceipttApi } from "redux/actions/myOrders";
import { PrintContainer, ChatBlockStyle } from "./orderBoxStyled";
import { DownloadBOL } from './trackDetailTypeTwoStyled'
// import PalletImage from "web/assets/images/pallet-home-image.webp";
import PalletImage from 'web/assets/images/pallet-home-image.jpg';

import { fetchLanguageContentNew } from "redux/actions/language";
import GiveRatingComponent from "./GiveRatingComponent";
import ChatBlock from "./ChatBlock";

const OrderBox = ({
  response,
  orderType,
  imageUpload,
  deliveableFlag,
  callBackFun,
  allOrderShipDeliverCallback,
  reviewRatingFun,
  openOrderCallBack,
  canceledOrderCallBack,
  rescheduleCallBack,
  deliveredOrderCallBack,
  downloadCallBack,
  callBackTimmer,
  modalCallBack,
  expanded,
  displayHoldBanner,
  displayHoldBannerFunc
}) => {
  const dispatch = useDispatch();
  let history = useHistory();
  const fileUrl = process.env.REACT_APP_API_URL + "/user/image/";
  const [stateVal, setState] = useState({ items: [] });
  const [stateReferenceVal, setStateReferenceVal] = useState({ items: [] });
  const [statePtmsReferenceVal, setStatePtmsReferenceVal] = useState({ items: [] });
  const token = localStorage.getItem("token");
  const locationID = localStorage.getItem("locationID");
  const [purchaseOrderState, setPurchaseOrderState] = useState("");
  const [modalBOL, setModalBOL] = useState(false);
  const [modalBOLContent, setModalBOLContent] = useState("");
  const [modalBOLLink, setModalBOLLink] = useState("/");
  const [modalBOLType, setModalBOLType] = useState("");
  const toggleBOLModal = () => setModalBOL(!modalBOL);
  const [selectedItem, setSelectedItem] = useState();
  const [chatBottomStackedOrders, setChatBottomStackedOrders] = useState([])

  const [oredrId, setOderId] = useState();

  const [onHoldModal, setOnHoldModal] = useState();
  const toggleOnHoldModal = () => setOnHoldModal(!onHoldModal);

  const [requestType, setRequestType] = useState();
  const [cancelOrderId, setCancelOrderId] = useState();
  const [itemState, setItemState] = useState();
  const [cancelOrderModal, setCancelOrderModal] = useState(false);
  const cancelOrderToggleModal = () => setCancelOrderModal(!cancelOrderModal);

  const [claimRaiseId, setClaimRaiseId] = useState();
  const [claimRaiseModal, setClaimRaiseModal] = useState(false);
  const claimRaiseToggleModal = () => setClaimRaiseModal(!claimRaiseModal);

  const [modal, setModal] = useState(false);
  const [alertType, setAlertType] = useState();
  const [modalContent, setModalContent] = useState("");
  const [modalLink, setModalLink] = useState("/");
  const toggleModal = () => setModal(!modal);

  const currentLanguage = useSelector((state) => state.language.currentLanguage);
  const languageContentNew = useSelector((state) => state.language.languageContentNew);
  const [pageLanguageContents, setPageLanguageContents] = useState();

  useEffect(() => {
    if (languageContentNew?.My_Orders_Page) setPageLanguageContents(languageContentNew.My_Orders_Page)
    else dispatch(fetchLanguageContentNew(currentLanguage));
  }, [languageContentNew]);


  useEffect(() => {
    // this is for showing a banner in case of failed payment

    getHoldOrdersListFunc()
  }, [])

  const getHoldOrdersListFunc = async () => {
    let holdOrderCount = 0
    if (response?.orders?.content && orderType === 'openOrder' && displayHoldBanner) {
      let responseOrders = await dispatch(getHoldOrdersList(locationID, token));
      holdOrderCount = responseOrders?.payload?.filter(item => item.orderStatus === 'HOLD' && locationID === item.buyerInfo?.locationId).length
      displayHoldBannerFunc(false)
    }
    if (holdOrderCount > 0) {
      setModalContent('Please update the card details for the HOLD order');
      setModalLink("");
      toggleModal();
    }
  }

  let title = "";

  const statusSet = (status) => {
    if (status === "PENDING") {
      status = (
        <span className="greenStatus" >
          {pageLanguageContents?.AllOrders[0]?.Pending}
        </span>
      );
    } else if (status === "ACCEPTED") {
      status = (
        <span className="greenStatus">
          {pageLanguageContents?.AllOrders[1]?.Accepted}
        </span>
      );
    } else if (status === "AVAILABLE") {
      status = (
        <span className="greenStatus">
          {pageLanguageContents?.AllOrders[2]?.Available}
        </span>
      );
    } else if (status === "PLACED") {
      status = (
        <span className="greenStatus">
          {pageLanguageContents?.AllOrders[3]?.Placed}
        </span>
      );
    } else if (status === "ASSIGNED") {
      status = (
        <span className="greenStatus">
          {pageLanguageContents?.AllOrders[4]?.Assigned}
        </span>
      );
    } else if (status === "LOADED") {
      status = (
        <span className="greenStatus">
          {pageLanguageContents?.AllOrders[5]?.Loaded}
        </span>
      );
    } else if (status === "SHIPPED") {
      status = (
        <span className="greenStatus">
          {pageLanguageContents?.AllOrders[6]?.Shipped}
        </span>
      );
    } else if (status === "DELIVERED") {
      status = (
        <span className="greenStatus">
          {pageLanguageContents?.AllOrders[7]?.Delivered}
        </span>
      );
    } else if (status === "AUTHORIZED") {
      status = (
        <span className="greenStatus">
          {pageLanguageContents?.AllOrders[8]?.Authorized}
        </span>
      );
    } else if (status === "CAPTURED") {
      status = (
        <span className="greenStatus">
          {pageLanguageContents?.AllOrders[9]?.Captured}
        </span>
      );
    } else if (status === "AUTHORIZED_FAIL") {
      status = (
        <span className="greenStatus">
          {pageLanguageContents?.AllOrders[10]?.PaymentFailed}
        </span>
      );
    } else if (status === "CLAIM") {
      status = (
        <span className="redStatusColour">
          {pageLanguageContents?.AllOrders[11]?.ClaimRaised}
        </span>
      );
    } else if (status === "CANCELLED") {
      status = (
        <span className="redStatusColour">
          Canceled
        </span>
      );
    } else if (status === "COMPLETE") {
      status = (
        <span className="blackStatus">
          {pageLanguageContents?.AllOrders[13]?.Complete}
        </span>
      );
    } else if (status === "RESCHEDULED") {
      status = <span className="yellowStatus">Reschedule</span>;
    } else if (status === "HOLD") {
      status = <span className="yellowStatus">{status}</span>;
    } else {
      status = <span className="greenStatus">{status}</span>;
    }

    return status;
  };

  const quickActionFunction = (orderType, items, index) => {
    const rescheduleFunctionCall = e => {
      e.stopPropagation();
      setCancelOrderId(items.id);
      setItemState(items);
      setRequestType("CANCEL");
      cancelOrderToggleModal();
    };

    const shipDeliverAction = e => {
      e.stopPropagation();
      if (items.orderStatus === "ASSIGNED") {
        if (orderType === 'allOrder') allOrderShipDeliverCallback(items.id, "SHIPPED")
        else callBackFun(items.id, "SHIPPED");
      } else {
        setSelectedItem(items);
        setModalBOLType('upload');
        toggleBOLModal();
      }
    };

    const printPodFunction = e => {
      e.stopPropagation();
      if (items.fileBOL) {
        imageUpload(items.fileBOL);
      }
    }

    const printReceiptFunction = e => {
      e.stopPropagation();
      downloadCallBack(items.id)
    }

    const resolutionCenterRedirectFunction = e => {
      e.stopPropagation();
      let obj = { expanded: "sideBar" };
      if (items.userType === "BUYER") obj.selectedTab = "CLAIM_RAISED"
      else obj.selectedTab = "CLAIM_DETAILS"
      dispatch({ type: 'RESOLUTION_CENTER', payload: obj });
      history.push('/resolution-center');
    }

    const chatBlockFunction = () => (
      <ChatBlockStyle>
        <ChatBlock
          orderDetails={items}
          isAccordionOpen={expanded1.includes(`panel${index}`)}
          chatBottomStackedOrders={chatBottomStackedOrders}
          setChatBottomStackedOrders={(type, id) => {
            if (type === 'removeAll') {
              setChatBottomStackedOrders([])
            } else if (type === 'add') {
              setChatBottomStackedOrders(prevOrders => {
                if (prevOrders.includes(id)) return prevOrders;
                else return [...prevOrders, id];
              });
            } else {
              setChatBottomStackedOrders(prevOrders => prevOrders.filter(item => item !== id));
            }
          }}
        />
      </ChatBlockStyle>
    );

    const renderOpenOrderActions = () => {
      let reqDate = moment(items?.contactInfo?.requestedDate)
      let isNotPrevDay = true
      if (reqDate.isBefore(moment(), 'day')) isNotPrevDay = false
      if (items.userType === "BUYER") {
        return (
          <>
            {(isNotPrevDay && items.orderStatus === "ASSIGNED" && (!items.rescheduleOrder || items.rescheduleOrder?.rescheduleOrderStatus === "PENDING")) ?
              <div onClick={rescheduleFunctionCall}><span className="darkBlueBg">Reschedule</span></div> :
              <div style={{ width: '100px' }}></div>}
            {chatBlockFunction()}
          </>
        );
      } else if (items.userType === "SELLER") {
        return (
          <>
            {(items.orderStatus === "SHIPPED" || items.orderStatus === "ASSIGNED") && (!items.rescheduleOrder || items.rescheduleOrder.rescheduleOrderStatus === "ACCEPTED" || items.rescheduleOrder.rescheduleOrderStatus === "PENDING") ?
              <div onClick={shipDeliverAction}><span className="darkBlueBg">{items.orderStatus === "SHIPPED" ? 'Deliver' : 'Ship'}</span></div> :
              <div style={{ width: '100px' }}></div>}
            {chatBlockFunction()}
          </>
        );
      }
    };

    let orderTypeValues
    if (orderType === 'openOrder' || items.orderStatus === "SHIPPED" || items.orderStatus === "ASSIGNED" || items.orderStatus === "RESCHEDULED") orderTypeValues = 'openOrder'
    else if (orderType === 'deliveredOrder' || items.orderStatus === 'DELIVERED') orderTypeValues = 'deliveredOrder'
    else if (orderType === 'claimOrder' || items.orderStatus === 'CLAIM') orderTypeValues = 'claimOrder'
    else if (orderType === 'completeOrder' || items.orderStatus === 'COMPLETE') orderTypeValues = 'completeOrder'
    else if (orderType === 'cancelOrder' || items.orderStatus === 'CANCELLED') orderTypeValues = 'cancelOrder'

    let returnBlock;
    switch (orderTypeValues) {
      case 'openOrder':
        returnBlock = renderOpenOrderActions();
        break;
      case 'deliveredOrder':
        returnBlock = (
          <>
            <div onClick={printPodFunction}><span className="darkBlueBg">Print POD</span></div>
            {chatBlockFunction()}
          </>
        );
        break;
      case 'claimOrder':
        returnBlock = (
          <>
            <div onClick={resolutionCenterRedirectFunction}><span className="darkBlueBg">View Claim</span></div>
            {chatBlockFunction()}
          </>
        );
        break;
      case 'completeOrder':
        returnBlock = (
          <>
            <div onClick={printPodFunction}><span className="darkBlueBg">Print POD</span></div>
            <div onClick={printReceiptFunction}><span className="blueBg">Receipt</span></div>
          </>
        );
        break;
      case 'cancelOrder':
        returnBlock = (
          <>
            <div><span className="cancelBg">{items.orderCancelDetails?.created && moment(items.orderCancelDetails?.created * 1000).format('MM/DD/YYYY HH:mm')}</span></div>
          </>
        );
        break;
      default:
        returnBlock = null;
    }

    return returnBlock;
  };

  const callPurchaseOrder = async (id, poNumber) => {
    if (token === null) {
      setModalContent("Please Sign In again.");
      setModalLink("/");
      toggleModal();
    } else {
      let response = "";
      let data = {
        orderId: id,
        poNumber: poNumber,
      };
      response = await dispatch(updatePoNumber(data, token));

      if (response.status === "SUCCESS") {
        setModalContent(response.message);
        setModalLink("");
        toggleModal();
      } else {
        if (response.statusCode === 401) {
          history.push('./sign-in')
          window.location.reload(false);
        } else {
          setModalContent(response.message);
          setModalLink("");
          toggleModal();
        }
      }
    }
  };

  const callReferenceNumber = async (id, referenceNumber) => {
    if (token === null) {
      setModalContent("Please Sign In again.");
      setModalLink("/");
      toggleModal();
    } else {
      let data = {
        orderId: id,
        referenceNumber: referenceNumber,
      };
      let response = await dispatch(updateReferenceNumber(data, token));

      if (response.status === "SUCCESS") {
        setModalContent(response.message);
        setModalLink("");
        toggleModal();
      } else {
        if (response.statusCode === 401) {
          history.push('./sign-in')
          window.location.reload(false);
        } else {
          setModalContent(response?.data?.error?.message || response?.data?.message || response?.message || 'Something went wrong, please try again in some time.');
          setModalLink("");
          toggleModal();
        }
      }
    }
  };

  useEffect(() => {
    paymentMethodAPI();
    let arr = [];
    let refArr = [];
    let ptmsRefArr = [];
    if (response.orders?.content?.length) {
      arr = response.orders.content.map(order => ({
        poNumber: order.poNumber,
        flag: true,
      }));

      refArr = response.orders.content.map(order => ({
        referenceNumber: order?.referenceNumber,
        flag: true,
      }));

      ptmsRefArr = response.orders.content.map(order => ({
        referenceNumber: order?.orderRefNumber || order?.referenceNumber,
        flag: true,
      }));

      setState({ items: arr });
      setStateReferenceVal({ items: refArr });
      setStatePtmsReferenceVal({ items: ptmsRefArr });
    }
  }, [response]);

  const [paymentResponse, setPaymentResponse] = useState(undefined);
  const paymentMethodAPI = async () => {
    if (token === null) {
      setModalContent("Please Sign In again.");
      setModalLink('/sign-in');
      toggleModal();
    } else {

      let response = await dispatch(paymentMethod(token));
      if (response.status === "SUCCESS") {
        if (response.payload.length !== 0) {
          setPaymentResponse(response.payload);
        }
      } else {
        if (response.statusCode === 401) {
          history.push('./sign-in')
          window.location.reload(false);
        } else {
          setModalContent(response?.data?.error?.message || response?.data?.message || response?.message || 'Something went wrong, please try again in some time.');
          setModalLink("");
          toggleModal();
        }
      }
    }
  };

  const statusBar = (items) => {
    return (
      <>
        <div className="tracking-details">
          <ul className="delivery-timeline-buyer">
            <li className="active">
              <div className="d-icon">
                <span>
                  {pageLanguageContents?.AllOrders[14]?.ORDER}
                </span>
              </div>
            </li>
            <li className="active">
              <div className="d-icon">
                <span>
                  {pageLanguageContents?.AllOrders[15]?.SHIPPED}
                </span>
              </div>
            </li>
            <li className="active">
              <div className="d-icon">
                <span>
                  {pageLanguageContents?.AllOrders[16]?.DELIVERED}
                </span>
              </div>
            </li>
          </ul>
        </div>
      </>
    );
  };

  const callUpdateBOL = async (status, values) => {
    if (token === null) {
      setModalContent("Please Sign In again.");
      setModalLink("/");
      toggleModal();
    } else {
      let data;
      let formData = new FormData();
      data = {
        orderId: selectedItem.id,
      };
      formData.append("request", JSON.stringify(data));
      formData.append("file", values.bolDocument);
      let response = await dispatch(updateBOL(formData, token));
      if (response.status === "SUCCESS") {
        setAlertType("success")
        setModalContent(response.message);
        setModalLink("");
        toggleModal();
      } else {
        if (response.statusCode === 401) {
          history.push('./sign-in')
          window.location.reload(false);
        } else {
          setModalContent(response?.data?.error?.message || response?.data?.message || response?.message || 'Something went wrong, please try again in some time.');
          setModalLink("");
          toggleModal();
        }
      }
    }
  };

  const requestedDateTime = (items, type) => {
    let startTime, hour, minute, endTime, endHour, endMinute;

    if (type === "rescheduleOrder" && items?.rescheduleOrder) {
      startTime = items.rescheduleOrder.requestedStartTime && items.rescheduleOrder.requestedStartTime.split(":");
      hour = startTime && startTime[0];
      minute = startTime && startTime[1];

      endTime = items.rescheduleOrder.requestedEndTime && items.rescheduleOrder.requestedEndTime.split(":");
      endHour = endTime && endTime[0];
      endMinute = endTime && endTime[1];
    } else {
      startTime = items.contactInfo.requestedStartTime && items.contactInfo.requestedStartTime.split(":");
      hour = startTime && startTime[0];
      minute = startTime && startTime[1];

      endTime = items.contactInfo.requestedEndTime && items.contactInfo.requestedEndTime.split(":");
      endHour = endTime && endTime[0];
      endMinute = endTime && endTime[1];
    }

    return (
      <>
        &nbsp;
        <span>{hour + ":" + minute}</span>-
        <span>{endHour + ":" + endMinute}</span>
      </>
    );
  };

  const orangeBadge = {
    background: "#ff6008",
    fontSize: "13px",
    // lineHeight: "1.67",
    color: "#ffffff",
    padding: "6px",
    // margin: "12px 15px 14px 0px",
    borderRadius: "3px",
    whiteSpace: 'nowrap',
    position: 'relative',
    bottom: '2px'
  };

  const [expanded1, setExpanded1] = useState([]);
  const handleChange = (panel) => (event, isExpanded) => {
    if (isExpanded) {
      setExpanded1(prevExpanded => [...prevExpanded, panel]);
    } else {
      setExpanded1(prevExpanded => prevExpanded.filter(item => item !== panel));
    }
  };

  const downloadCreditMemo = async (id) => {
    let token = localStorage.getItem('token')
    let response = await dispatch(downloadCreditMemoApiCall(id, token));

    const url = window.URL.createObjectURL(new Blob([response]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "Credit Memo.pdf");
    document.body.appendChild(link);
    link.click();
  }

  const downloadCancelReceipt = async (id) => {
    let response = await dispatch(downloadCancelReceiptApi(id, token));
    const url = window.URL.createObjectURL(new Blob([response]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "Cancel Receipt.pdf");
    document.body.appendChild(link);
    link.click();
  };

  const downloadRebateReceipt = async (id) => {
    let response = await dispatch(downloadRebateReceipttApi(id, token));
    const url = window.URL.createObjectURL(new Blob([response]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "Rebate Receipt.pdf");
    document.body.appendChild(link);
    link.click();
  };

  const downloadBolTemplate = async (documentData) => {
    const blob = await pdf((
      <PdfDocument
        items={documentData}
      />
    )).toBlob();
    saveAs(blob, 'delivery-bol-form');
  };

  const formOrderDetailsString = items => {
    let details = [];

    if (items?.orderDetails?.material) {
      details.push(items.orderDetails.material);
    }
    if (items?.orderDetails?.condition?.length) {
      let condition = items.orderDetails.condition.join(', ');

      if (items?.orderDetails?.newConditionType === 'HARDWOOD') {
        condition += ' (HW)';
      } else if (items?.orderDetails?.newConditionType === 'SOFTWOOD') {
        condition += ' (SW)';
      }

      details.push(condition);
    }
    if (items?.orderDetails?.commodity?.commodityName) {
      details.push(items.orderDetails.commodity.commodityName);
    }
    if (items?.orderDetails?.moistureContent) {
      details.push(items.orderDetails.moistureContent);
    }
    if (items?.orderDetails?.grade?.gradeName && items.orderDetails.grade.gradeName !== 'Custom') {
      details.push(items.orderDetails.grade.gradeName);
    }
    if (items?.orderDetails?.grade?.gradeName === 'Custom') {
      details.push('Custom');
    }
    if (items?.orderDetails?.dimension?.height) {
      let dimension = `${items.orderDetails.dimension.length}x${items.orderDetails.dimension.width}x${items.orderDetails.dimension.height}`;
      details.push(dimension);
    }
    if (items?.orderDetails?.grade?.sizeWiseGrad) {
      details.push(items.orderDetails.grade.sizeWiseGrad);
    }
    return details.join(', ');
  }

  return (
    <>
      {stateVal.items &&
        response.orders.content.length !== 0 &&
        stateVal.items.length === response.orders.content.length ? (
        <>
          {response.orders.content.map((items, index) => {
            return (
              <div className="product-block post-accordion" key={index}>
                <Accordion
                  expanded1={expanded === `panel${index}`}
                  onChange={handleChange(`panel${index}`)}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1bh-content"
                    id="panel1bh-header"
                  >
                    <div className="product-block-heading" style={{ paddingLeft: "50px", width: "100%" }}>
                      <img
                        src={items.userType === "BUYER" ? RightArrow : RightArrowLight}
                        alt="RightArrow"
                        className="right-arrow"
                      />
                      <OpenOrderMain>
                        <FirstSction>
                          <div className="heading-with-status">
                            <h6 style={{ minWidth: "260px", fontFamily: "latosemibold", marginRight: '10px' }}>
                              <Tooltip placement="top" arrow title={items.orderDetails.title || items.id} enterTouchDelay={0}>
                                <a onClick={(e) => { }}>
                                  {items.orderDetails.title || items.id}
                                </a>
                              </Tooltip>
                            </h6>
                            <StatusWrapper className="mobile-view-status">
                              {statusSet(items.orderStatus)}
                            </StatusWrapper>
                          </div>
                          <h6 className={!items.poNumber && "po-number-tag"} style={{ minWidth: "180px", fontSize: '17px', color: '#191819', marginRight: '10px' }}>
                            {items.poNumber && (
                              <Tooltip placement="top" arrow title={items.poNumber} enterTouchDelay={0}>
                                <a onClick={(e) => { }}>
                                  {items.poNumber}
                                  {/* {String(items.poNumber).slice(0, 8)}{items.poNumber.length >= 8 ? "..." : ""} */}
                                </a>
                              </Tooltip>
                            )}
                          </h6>
                          <p style={{ textAlign: "left", minWidth: "130px" }}>
                            <span style={{ minWidth: "130px" }}>
                              (<Tooltip placement="top" arrow title={items.contactInfo.address.city} enterTouchDelay={0}>
                                <a onClick={(e) => { }}>
                                  {String(items.contactInfo.address.city).slice(0, 12)}{items.contactInfo.address.city.length >= 18 ? ".." : ""}
                                </a>
                              </Tooltip>,&nbsp;{stateConvert(items.contactInfo.address.state) || items.contactInfo.address.state})
                            </span>
                          </p>
                          <div className="mobile-view-status">
                            {items.orderStatus === "COMPLETE" || items.orderStatus === "DELIVERED" ? (
                              <div>
                                {moment(items.userType === "BUYER" ? items.buyerDeliveryDate : items.sellerDeliveryDate).format("MM/DD/YYYY")}
                              </div>
                            ) : items.rescheduleOrder && (items.orderStatus === "RESCHEDULED" || items.rescheduleOrder?.rescheduleOrderStatus === "ACCEPTED") ? (
                              <div>
                                {moment(items.userType === "BUYER" ? items.rescheduleOrder.buyerRescheduledDate : items.rescheduleOrder.sellerRescheduledDate).format(FORMAT)}
                              </div>
                            ) : (
                              <div>
                                {moment(items.contactInfo.requestedDate).format("MM/DD/YYYY")}
                              </div>
                            )}
                          </div>
                        </FirstSction>
                        <SecondSction>
                          <div className="web-view-status">
                            {items.orderStatus === "COMPLETE" || items.orderStatus === "DELIVERED" ? (
                              <div>
                                {moment(items.userType === "BUYER" ? items.buyerDeliveryDate : items.sellerDeliveryDate).format("MM/DD/YYYY")}
                              </div>
                            ) : items.rescheduleOrder && (items.orderStatus === "RESCHEDULED" || items.rescheduleOrder?.rescheduleOrderStatus === "ACCEPTED") ? (
                              <div>
                                {moment(items.userType === "BUYER" ? items.rescheduleOrder.buyerRescheduledDate : items.rescheduleOrder.sellerRescheduledDate).format(FORMAT)}
                              </div>
                            ) : (
                              <div>
                                {moment(items.contactInfo.requestedDate).format("MM/DD/YYYY")}
                              </div>
                            )}
                          </div>
                          <StatusWrapper className="web-view-status status-min-width">
                            &nbsp;{statusSet(items.orderStatus)}
                          </StatusWrapper>
                          <QuickButtonWrapper>
                            {quickActionFunction(orderType, items, index)}
                          </QuickButtonWrapper>
                        </SecondSction>
                      </OpenOrderMain>
                    </div>
                  </AccordionSummary>
                  <AccordionDetails>
                    <div className="product-block-details">
                      <div className="product-block-description">
                        <div>
                          {items.claim && items.claim.isPickedUpIssuesPallet && items.claim.returnPickUpDate && (
                            <p className="colorfull" style={{ color: "red" }}>
                              Seller to Pickup Pallets on {moment(items.claim.returnPickUpDate).format(FORMAT)}
                            </p>
                          )}
                        </div>
                        <div className="product-block-rows border-bottom">
                          <div className="row text-success">
                            <div className="col-50 text-bold">
                              <span>Buyer Name</span>
                            </div>
                            <div className="col-50 flex-column-align-start" style={{ display: 'flex', flexWrap: 'wrap' }}>
                              <span className="product-block-username" title={items.buyerInfo?.companyName}>{items.buyerInfo.companyName}</span>
                              {items.id?.toLowerCase().includes('exchange') && (
                                <span style={orangeBadge}>Exchange Order</span>
                              )}
                            </div>
                          </div>
                          {items.orderDetails.title !== items.id && //this condition is for delivery vendor pricing request orders, where order id and post name are same, so no need to display post name
                            <div className="row">
                              <div className="col-50 text-bold">
                                <span>Post Name</span>
                              </div>
                              <div className="col-50">
                                <span>{items.orderDetails.title || items.id}</span>
                              </div>
                            </div>
                          }
                          <div className="row">
                            <div className="col-50 text-bold">
                              <span>{pageLanguageContents?.AllOrders[18]?.OrderID}</span>
                            </div>
                            <div className="col-50">
                              <span>{items.id}</span>
                            </div>
                          </div>
                          <div className="row">
                            {items.userType === "BUYER" ? (
                              <>
                                <div className="col-50 text-bold">
                                  <span>{pageLanguageContents?.AllOrders[19]?.PurchaseOrder}</span>
                                </div>
                                <div className="col-50">
                                  {["SHIPPED", "COMPLETE", "DELIVERED", "CANCELLED"].includes(items.orderStatus) ? (
                                    <div className="app-input-text">
                                      <div className="poNumberWidth app-input-text">
                                        {stateVal.items[index].poNumber || ""}
                                      </div>
                                    </div>
                                  ) : (
                                    <div className="app-input-text">
                                      <input
                                        style={{ maxWidth: "227px" }}
                                        name="purchaseOrder"
                                        type="text"
                                        maxLength="20"
                                        value={stateVal.items[index].poNumber || ""}
                                        disabled={stateVal.items[index].flag}
                                        onChange={(evt) => {
                                          let newArr = [...stateVal.items];
                                          newArr[index].poNumber = evt.currentTarget.value;
                                          setState({ items: newArr });
                                          setPurchaseOrderState(evt.currentTarget.value);
                                        }}
                                      />
                                      <div className="input-actions">
                                        {stateVal.items[index].flag ? (
                                          <span
                                            className="edit-icon"
                                            onClick={(e) => {
                                              let newArr = [...stateVal.items];
                                              newArr[index].flag = false;
                                              setState({ items: newArr });
                                            }}
                                          >
                                            <img src={EditIcon} alt="edit icon" />
                                          </span>
                                        ) : (
                                          <span
                                            onClick={(e) => {
                                              let newArr = [...stateVal.items];
                                              newArr[index].flag = true;
                                              setState({ items: newArr });
                                              callPurchaseOrder(items.id, stateVal.items[index].poNumber);
                                            }}
                                          >
                                            &#10004;
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </>
                            ) : (
                              <>
                                <div className="col-50 text-bold">
                                  <span>{pageLanguageContents?.AllOrders[19]?.PurchaseOrder}</span>
                                </div>
                                <div className="col-50">
                                  {stateVal.items[index].poNumber ? (
                                    <p className="poNumberWidth">{stateVal.items[index].poNumber || ""}</p>
                                  ) : (
                                    <p className="poNumberWidth">{pageLanguageContents?.AllOrders[26]?.NA}</p>
                                  )}
                                </div>
                              </>
                            )}
                          </div>
                        </div>

                        <div className="product-block-rows border-bottom">
                          <div className="row">
                            <div className="col-50 text-bold">
                              <span>Order Type:</span>
                            </div>
                            <div style={{ width: '50%', marginLeft: '50px' }}>
                              <span style={{ display: "block" }}>
                                {formOrderDetailsString(items)}
                                {/* {`${items?.orderDetails?.material ? items?.orderDetails?.material + ', ' : ''}${items?.orderDetails?.condition ? items?.orderDetails?.condition?.join(', ') + ',' : ''} ${items?.orderDetails?.newConditionType === 'HARDWOOD' ? '(HW), ' : (items?.orderDetails?.newConditionType === 'SOFTWOOD' ? '(SW), ' : '')}
                                ${items?.orderDetails?.commodity?.commodityName || ''}${items?.orderDetails?.moistureContent ? ', ' + items?.orderDetails?.moistureContent : ''}${items?.orderDetails?.grade?.gradeName && items?.orderDetails?.grade?.gradeName !== 'Custom' ? ', ' + items?.orderDetails?.grade?.gradeName : ''}${items?.orderDetails?.grade?.gradeName === 'Custom' ? ', ' : ''}${items?.orderDetails?.dimension?.height ? `${items?.orderDetails?.dimension?.length}x${items?.orderDetails?.dimension?.width}x${items?.orderDetails?.dimension?.height}` : ''}${items?.orderDetails?.grade?.sizeWiseGrad ? ', ' + items?.orderDetails?.grade?.sizeWiseGrad : ''}`} */}
                              </span>
                            </div>
                          </div>

                          <div className="row mt-3 mb-3">
                            <div className="col-50 text-bold">
                              <span>Order Quantity:</span>
                            </div>
                            <div className="col-50">
                              <span>{items?.orderDetails?.quantity?.toLocaleString()}</span>
                            </div>
                          </div>
                          <div className="row mt-3 mb-3">
                            <div className="col-50 text-bold">
                              <span>{pageLanguageContents?.AllOrders[20]?.UnitPrice}</span>
                            </div>
                            <div className="col-50">
                              <span>
                                <CurrencyFormat
                                  value={items.orderDetails.pricePerPallet?.toFixed(2)}
                                  displayType="text"
                                  thousandSeparator={true}
                                  prefix="$"
                                />
                                &nbsp;
                                <Tooltip
                                  placement="top"
                                  enterTouchDelay={0}
                                  arrow
                                  title={
                                    <>
                                      <p>{pageLanguageContents?.AllOrders[20]?.UnitPrice} ($): <span><CurrencyFormat value={items.orderDetails.pricePerPallet?.toFixed(2)} displayType="text" thousandSeparator={true} prefix="$" /></span></p>
                                      <p>{pageLanguageContents?.AllOrders[21]?.Tax} ($): <span><CurrencyFormat value={items.userType === "BUYER" ? items.buyerInfo.price.tax?.toFixed(2) : items.sellerInfo.price.tax?.toFixed(2)} displayType="text" thousandSeparator={true} prefix="$" /></span></p>
                                      <p>{pageLanguageContents?.AllOrders[22]?.ServiceCharge} ($): <span><CurrencyFormat value={items.userType === "BUYER" ? (items.buyerInfo?.price?.serviceCharge - items.buyerInfo?.price?.tax)?.toFixed(2) : items.sellerInfo.price.serviceCharge?.toFixed(2)} displayType="text" thousandSeparator={true} prefix="$" /></span></p>
                                    </>
                                  }
                                >
                                  <InfoText>
                                    <img src={infoicon} alt="tooltip icon" />
                                  </InfoText>
                                </Tooltip>
                              </span>
                            </div>
                          </div>

                          {items.userType === "BUYER" && items.promoCode && (
                            <div className="row mt-3 mb-3">
                              <div className="col-50 text-bold">
                                <span>Promocode:</span>
                              </div>
                              <div className="col-50">
                                <PromoAppliedTick />
                                <span style={{ color: '#68A107' }}>{items.promoCode}</span>
                              </div>
                            </div>
                          )}
                          <div className="row mt-3 mb-3">
                            <div className="col-50 text-bold">
                              <span>Seller Name</span>
                            </div>
                            <div className="col-50">
                              <span>{items.sellerInfo.companyName}</span>
                            </div>
                          </div>

                          <div className="row mt-3 mb-3">
                            {items?.userType !== "BUYER" && (
                              <>
                                <div className="col-50 text-bold">
                                  <span>Reference Number:</span>
                                </div>
                                <div className="col-50">
                                  <div className="app-input-text">
                                    <input
                                      style={{ maxWidth: "227px" }}
                                      name="referenceNumber"
                                      type="text"
                                      maxLength="20"
                                      value={stateReferenceVal.items[index].referenceNumber || ""}
                                      disabled={stateReferenceVal.items[index].flag}
                                      onChange={(evt) => {
                                        const newArr = [...stateReferenceVal.items];
                                        newArr[index].referenceNumber = evt.currentTarget.value;
                                        setStateReferenceVal({ items: newArr });
                                      }}
                                    />
                                    <div className="input-actions">
                                      {stateReferenceVal.items[index].flag ? (
                                        <span
                                          className="edit-icon"
                                          onClick={() => {
                                            const newArr = [...stateReferenceVal.items];
                                            newArr[index].flag = false;
                                            setStateReferenceVal({ items: newArr });
                                          }}
                                        >
                                          <img src={EditIcon} alt="edit icon" />
                                        </span>
                                      ) : (
                                        <span
                                          style={{ cursor: "pointer" }}
                                          onClick={() => {
                                            const newArr = [...stateReferenceVal.items];
                                            newArr[index].flag = true;
                                            setStateReferenceVal({ items: newArr });
                                            callReferenceNumber(items.id, stateReferenceVal.items[index].referenceNumber);
                                          }}
                                        >
                                          &#10004;
                                        </span>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </>
                            )}

                            {items?.userType === "BUYER" && items?.orderRefNumber && (
                              <>
                                <div className="col-50 text-bold">
                                  <span>PT+ Reference Number:</span>
                                </div>
                                <div className="col-50">
                                  <div className="app-input-text">
                                    <input
                                      style={{ maxWidth: "227px" }}
                                      name="referenceNumber"
                                      type="text"
                                      maxLength="20"
                                      value={statePtmsReferenceVal.items[index].referenceNumber || ""}
                                      disabled={statePtmsReferenceVal.items[index].flag}
                                      onChange={(evt) => {
                                        const newArr = [...statePtmsReferenceVal.items];
                                        newArr[index].referenceNumber = evt.currentTarget.value;
                                        setStatePtmsReferenceVal({ items: newArr });
                                      }}
                                    />
                                  </div>
                                </div>
                              </>
                            )}
                          </div>

                          {items.orderStatus === "CANCELLED" && (
                            <div className="row mt-3 mb-3">
                              <div className="col-50 text-bold">
                                {items.contactInfo.type === "PICKUP" ? (
                                  <span>Requested Pickup:</span>
                                ) : (
                                  <span>{pageLanguageContents?.AllOrders[25]?.RequestedDelivery}</span>
                                )}
                              </div>
                              <div className="col-50">
                                {items.contactInfo.requestedDate && (
                                  <span>
                                    {moment(items.contactInfo.requestedDate).format(FORMAT)}
                                  </span>
                                )}
                              </div>
                            </div>
                          )}

                          {(items.orderStatus !== "CANCELLED" && items.rescheduleOrder) && (
                            <div className="row mt-3 mb-3">
                              <div className="col-50 text-bold">
                                {items.contactInfo.type === "PICKUP" ? (
                                  <span>Requested Pickup:</span>
                                ) : (
                                  <span>{pageLanguageContents?.AllOrders[25]?.RequestedDelivery}</span>
                                )}
                              </div>
                              <div className="col-50">
                                {items.orderStatus === "COMPLETE" || items.orderStatus === "DELIVERED" ? (
                                  <span>
                                    {items.userType === "BUYER" ? (
                                      moment(items.rescheduleOrder?.buyerRescheduledDate).format(FORMAT)
                                    ) : (
                                      moment(items.rescheduleOrder?.sellerRescheduledDate).format(FORMAT)
                                    )}
                                    {requestedDateTime(items, "rescheduleOrder")}
                                  </span>
                                ) : (
                                  <span>
                                    {items.contactInfo.requestedDate === null ? (
                                      <span>{pageLanguageContents?.AllOrders[26]?.NA}</span>
                                    ) : (
                                      moment(items.contactInfo.requestedDate).format(FORMAT)
                                    )}
                                    {requestedDateTime(items)}
                                  </span>
                                )}
                              </div>
                            </div>
                          )}

                          {((!items.isClaimed && items.rescheduleOrder && items.rescheduleOrder?.rescheduleOrderStatus !== "PENDING") || (items.rescheduleOrder && items.id?.toLowerCase().includes('exchange'))) && (items.orderStatus !== "COMPLETE" && items.orderStatus !== "DELIVERED" && items.orderStatus !== "CANCELLED") && (
                            <div className="row mt-3 mb-3">
                              <div className="col-50 text-bold">
                                <span>{pageLanguageContents?.AllOrders[28]?.RescheduledDate2}</span>
                              </div>
                              <div className="col-50">
                                <p>
                                  {items.userType === "BUYER" ? (
                                    moment(items.rescheduleOrder?.buyerRescheduledDate).format(FORMAT)
                                  ) : (
                                    moment(items.rescheduleOrder?.sellerRescheduledDate).format(FORMAT)
                                  )}
                                  {requestedDateTime(items, "rescheduleOrder")}
                                </p>
                              </div>
                            </div>
                          )}

                          {(items.orderStatus !== "CANCELLED" && !items.rescheduleOrder && items.orderStatus === "RESCHEDULED") && (
                            <div className="row mt-3 mb-3">
                              <div className="col-50 text-bold">
                                <span>{pageLanguageContents?.AllOrders[29]?.RescheduledDate}</span>
                              </div>
                              <div className="col-50">
                                <p>
                                  {items.deliveryDate === null ? (
                                    <span>{moment(items.contactInfo.requestedDate).format(FORMAT)}</span>
                                  ) : (
                                    <span>{moment(items.deliveryDate).format(FORMAT)}</span>
                                  )}
                                  {requestedDateTime(items)}
                                </p>
                              </div>
                            </div>
                          )}

                          {items.orderStatus !== "CANCELLED" && !items.rescheduleOrder && items.orderStatus !== "RESCHEDULED" && (
                            <div className="row mt-3 mb-3">
                              <div className="col-50 text-bold">
                                {items.contactInfo.type === "PICKUP" ? (
                                  <span>Requested Pickup:</span>
                                ) : (
                                  <span>{pageLanguageContents?.AllOrders[25]?.RequestedDelivery}</span>
                                )}
                              </div>
                              <div className="col-50">
                                <p>
                                  {items.contactInfo.requestedDate === null ? (
                                    <span>{moment(items.contactInfo.requestedDate).format(FORMAT)}</span>
                                  ) : (
                                    <span>{moment(items.contactInfo.requestedDate).format(FORMAT)}</span>
                                  )}
                                  {requestedDateTime(items)}
                                </p>
                              </div>
                            </div>
                          )}

                          {(items.orderStatus === "COMPLETE" || items.orderStatus === "DELIVERED") && (
                            <div className="row mt-3 mb-3">
                              <div className="col-50 text-bold">
                                {items.contactInfo.type === "PICKUP" ? (
                                  <span>Actual Pickup Date:</span>
                                ) : (
                                  <span>{pageLanguageContents?.AllOrders[27]?.ActualDeliveryDate}</span>
                                )}
                              </div>
                              <div className="col-50">
                                <p>
                                  {(items.userType === "BUYER" && items.buyerDeliveryDate === null) || (items.userType === "SELLER" && items.sellerDeliveryDate === null) ? (
                                    items.orderStatus !== "ASSIGNED" && items.orderStatus !== "SHIPPED" ? (
                                      <span>{moment(items.contactInfo.requestedDate).format(FORMAT)}</span>
                                    ) : (
                                      <span>{pageLanguageContents?.AllOrders[26]?.NA}</span>
                                    )
                                  ) : (
                                    <span>
                                      {items.userType === "BUYER" ? moment(items.buyerDeliveryDate).format("MM/DD/YYYY h:mm a") : moment(items.sellerDeliveryDate).format("MM/DD/YYYY h:mm a")}
                                    </span>
                                  )}
                                </p>
                              </div>
                            </div>
                          )}
                        </div>

                        <div className="product-block-rows">
                          <div className="row mt-3 mb-3">
                            <div className="col-50 text-bold">
                              {items.contactInfo.type === "PICKUP" ? (
                                <span>{pageLanguageContents?.AllOrders[32]?.PickupAddress}</span>
                              ) : (
                                <span>{pageLanguageContents?.AllOrders[33]?.DeliveryAddress}</span>
                              )}
                            </div>
                            {items.contactInfo.address && (
                              <div className="col-50">
                                {items.contactInfo.address.name && (
                                  <b>{items.contactInfo.address.name}&nbsp;</b>
                                )}
                                <br />
                                {items.contactInfo.address.line1 && (
                                  <p>
                                    {items.contactInfo.address.line1}
                                    {items.contactInfo.address.line2 && `, ${items.contactInfo.address.line2}`}
                                  </p>
                                )}
                                <br />
                                <p>
                                  {items.contactInfo.address.city},&nbsp;
                                  {stateConvert(items.contactInfo.address.state) || items.contactInfo.address.state}&nbsp;
                                  {items.contactInfo.address.zip}
                                </p>
                              </div>
                            )}
                          </div>

                          <div className="product-block-rows">
                            <div className="row">
                              <div className="col-50 text-bold">
                                <span>Buyer Comment:</span>
                              </div>
                              <div className="col-50">
                                <div>
                                  {items.comments && items.comments.map((commentItem, index) => (
                                    commentItem.userType !== "SELLER" && (
                                      <div key={index}>
                                        <span style={{ wordBreak: "break-all" }}>
                                          {commentItem.comment}
                                        </span>
                                      </div>
                                    )
                                  ))}
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="product-block-rows">
                            <div className="row">
                              <div className="col-50 text-bold">
                                <span>Seller Comment:</span>
                              </div>
                              <div className="col-50">
                                <div>
                                  {items.comments &&
                                    items.comments.map((commentItem, index) => (
                                      commentItem.userType === "SELLER" && (
                                        <div key={index}>
                                          <span style={{ wordBreak: "break-all" }}>
                                            {commentItem.comment}
                                          </span>
                                        </div>
                                      )
                                    ))}
                                </div>
                              </div>
                            </div>
                          </div>

                          {items?.orderCancelDetails?.description && items.orderStatus === "CANCELLED" && (
                            <div className="product-block-rows">
                              <div className="row">
                                <div className="col-50 text-bold">
                                  <span>Canceled Comment:</span>
                                </div>
                                <div className="col-50">
                                  <div>
                                    <span
                                      style={{
                                        wordBreak: "break-all",
                                      }}
                                    >
                                      {items.orderCancelDetails.description}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                        <div style={{ marginTop: '-30px' }}>
                          {(orderType === "completeOrder" || (orderType === "allOrder" && items.orderStatus === "COMPLETE")) && (
                            <>
                              {(items.userType === "BUYER" || items.userType === "SELLER") && (
                                <>
                                  {(!items[`${items.userType.toLowerCase()}Rating`] && !items[`${items.userType.toLowerCase()}Review`]) ? (
                                    <GiveRatingComponent
                                      index={index}
                                      items={items}
                                      reviewRatingFun={reviewRatingFun}
                                    />
                                  ) : (
                                    <div className="product-block-rows">
                                      {items[`${items.userType.toLowerCase()}Rating`] != null &&
                                        Number(items[`${items.userType.toLowerCase()}Rating`]) > 0 && (
                                          <div className="row">
                                            <div className="col-50 text-bold">
                                              <span>Rating:</span>
                                            </div>
                                            <div className="col-50">
                                              <div>
                                                <Rating
                                                  readOnly
                                                  name="simple-controlled"
                                                  value={Number(items[`${items.userType.toLowerCase()}Rating`])}
                                                />
                                              </div>
                                            </div>
                                          </div>
                                        )}

                                      {items[`${items.userType.toLowerCase()}Review`] && items[`${items.userType.toLowerCase()}Review`] !== '' && (
                                        <div className="row">
                                          <div className="col-50 text-bold">
                                            <span>Review:</span>
                                          </div>
                                          <div className="col-50">
                                            <div>
                                              <span style={{ wordBreak: "break-all" }}>{items[`${items.userType.toLowerCase()}Review`]}</span>
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                  )}
                                </>
                              )}
                            </>
                          )}
                        </div>

                        {items.timeLeftToRaiseDispute === 0 && orderType === "completeOrder" && (
                          <PrintContainer>
                            <p onClick={() => downloadCallBack(items.id)}>
                              {pageLanguageContents?.DetailedContents[5]?.DownloadInvoice}
                            </p>

                            {items.userType === "BUYER" && items.promoInvoiceId && (
                              <p onClick={() => downloadRebateReceipt(items.promoInvoiceId)}>
                                Rebate Receipt
                              </p>
                            )}

                            {(items.userType === 'BUYER' && items.buyerCreditMemoId) ?
                              <p onClick={() => downloadCreditMemo(items.buyerCreditMemoId)}>Buyer Credit Memo</p>
                              :
                              items.sellerCreditMemoId ?
                                <p onClick={() => downloadCreditMemo(items.sellerCreditMemoId)}>Seller Credit Memo</p>
                                : ''
                            }

                            <p onClick={() => {
                              if (items.fileBOL) {
                                imageUpload(items.fileBOL);
                              } else {
                                setModalContent('Please upload BOL first.');
                                setModalLink("");
                                toggleModal();
                              }
                            }}>
                              {items.userType === "BUYER" ? "Print POD" : "Print BOL/POD"}
                            </p>
                          </PrintContainer>
                        )}

                        {orderType === "allOrder" && (
                          <PrintContainer>
                            {(items.orderStatus !== "CLAIM" &&
                              items.orderStatus !== "RESCHEDULED" &&
                              items.orderStatus !== "CANCELLED" &&
                              items.orderStatus !== "DELIVERED" &&
                              items.orderStatus !== "ASSIGNED" &&
                              items.orderStatus !== "HOLD" &&
                              items.orderStatus !== "SHIPPED") ? (
                              <>
                                <p onClick={() => downloadCallBack(items.id)}>
                                  {pageLanguageContents?.DetailedContents[5]?.DownloadInvoice}
                                </p>

                                {(items.userType === "BUYER" && items.promoInvoiceId && items.orderStatus === "COMPLETE") && (
                                  <p onClick={() => downloadRebateReceipt(items.promoInvoiceId)}>
                                    Rebate Receipt
                                  </p>
                                )}

                                {(items.userType === 'BUYER' && items.buyerCreditMemoId) ?
                                  <p onClick={() => downloadCreditMemo(items.buyerCreditMemoId)}>Buyer Credit Memo</p>
                                  :
                                  items.sellerCreditMemoId ?
                                    <p onClick={() => downloadCreditMemo(items.sellerCreditMemoId)}>Seller Credit Memo</p>
                                    : ''
                                }
                              </>
                            ) : (
                              <h6></h6>
                            )}

                            {(items.orderStatus !== "CANCELLED" &&
                              items.orderStatus !== "ASSIGNED" &&
                              items.orderStatus !== "SHIPPED" &&
                              items.orderStatus !== "RESCHEDULED" &&
                              items.orderStatus !== "HOLD") ? (
                              <p onClick={() => {
                                if (items.fileBOL) {
                                  imageUpload(items.fileBOL);
                                } else {
                                  setModalContent('Please upload BOL first.');
                                  setModalLink("");
                                  toggleModal();
                                }
                              }}>
                                {items.userType === "BUYER"
                                  ? "Print POD" : "Print BOL/POD"}
                              </p>
                            ) : (
                              <h6></h6>
                            )}
                          </PrintContainer>
                        )}

                        <PrintContainer>
                          <div></div>
                          <div style={{ display: 'flex' }}>
                            {(items.orderStatus === 'CANCELLED' && items.userType === 'BUYER' && items.buyerInvoiceNumber) &&
                              <p style={{ marginRight: '10px' }} onClick={() => downloadCancelReceipt(items.buyerInvoiceNumber)}>
                                Cancel Receipt
                              </p>
                            }
                            {(items.orderStatus === 'CANCELLED' && items.userType === 'SELLER' && items.sellerInvoiceNumber) &&
                              <p onClick={() => downloadCancelReceipt(items.sellerInvoiceNumber)}>
                                Cancel Receipt
                              </p>
                            }
                          </div>
                        </PrintContainer>

                        {orderType === "deliveredOrder" && statusBar(items)}

                        <div>
                          {(!["cancelOrder", "allOrder", "completeOrder"].includes(orderType)) ? (
                            <>
                              {(deliveableFlag && orderType !== 'openOrder') ? (
                                <>
                                  <TrackDetailTypeDelivered
                                    response={response}
                                    index={index}
                                    items={items}
                                    callBackFun={callBackFun}
                                    imageUpload={imageUpload}
                                    downloadCallBack={downloadCallBack}
                                    callBackTimmer={callBackTimmer}
                                    canceledOrderCallBack={items.userType === "SELLER" ? canceledOrderCallBack : undefined}
                                  />
                                </>
                              ) : (
                                <>
                                  {items.userType === "BUYER" ? (
                                    <TrackDetailTypeOne
                                      items={items}
                                      callBackFun={callBackFun}
                                      canceledOrderCallBack={canceledOrderCallBack}
                                      rescheduleCallBack={rescheduleCallBack}
                                      downloadCallBack={downloadCallBack}
                                      orderType={orderType}
                                      modalCallBack={(id, action, props) => modalCallBack(id, action, props)}
                                    />
                                  ) : (
                                    <TrackDetailTypeTwo
                                      items={items}
                                      callBackFun={callBackFun}
                                      canceledOrderCallBack={canceledOrderCallBack}
                                      rescheduleCallBack={rescheduleCallBack}
                                      downloadCallBack={downloadCallBack}
                                      orderType={orderType}
                                      modalCallBack={(id, action, props) => modalCallBack(id, action, props)}
                                    />
                                  )}
                                </>
                              )}
                            </>
                          ) : (
                            <>
                              {orderType === "deliveredOrder" && (
                                <TrackDetailTypeCancel
                                  items={items}
                                  orderType={orderType}
                                  callBackFun={callBackFun}
                                  canceledOrderCallBack={canceledOrderCallBack}
                                />
                              )}
                            </>
                          )}
                        </div>

                        <PrintContainer>
                          {(items.orderDetails.title === items.id && (items.orderStatus === "ASSIGNED" || items.orderStatus === "SHIPPED") && items.userType === 'SELLER') &&
                            <div>
                              <p className="text-success" onClick={() => downloadBolTemplate(items)}>
                                Download BOL Form
                              </p>
                            </div>
                          }
                          {(!(moment(items?.contactInfo?.requestedDate).isBefore(moment(), 'day')) && items.orderStatus === "ASSIGNED" && orderType !== "allOrder" && (!items.rescheduleOrder || items.rescheduleOrder?.rescheduleOrderStatus === "PENDING")) && (
                            <div>
                              <p className="text-success" style={{ width: 'fit-content' }} onClick={() => {
                                setCancelOrderId(items.id);
                                setItemState(items);
                                setRequestType("CANCEL");
                                cancelOrderToggleModal();
                              }}>
                                {(items.orderDetails.material === "OTHER" || items.orderDetails.dimension.height) && items.userType === "BUYER"
                                  ? "Reschedule Order" : "Cancel or Reschedule Order"}
                              </p>
                            </div>
                          )}
                        </PrintContainer>
                        <PrintContainer>
                          {(items.orderStatus === "HOLD" && items.userType === "BUYER" && (orderType === "openOrder" || orderType === "allOrder")) && (
                            <div>
                              <p className="text-success" onClick={() => {
                                toggleOnHoldModal();
                                setOderId(items.id);
                              }}>
                                Retry Payment
                              </p>
                            </div>
                          )}
                          {(orderType === "deliveredOrder" && items.orderDetails.pricePerPallet * items.orderDetails.quantity > 10 && items.timeLeftToRaiseDispute !== 0 && items.userType !== "SELLER") && (
                            <div>
                              <a onClick={() => {
                                setClaimRaiseId(items.id);
                                claimRaiseToggleModal();
                              }}>
                                {pageLanguageContents?.DetailedContents[1]?.Concern}
                              </a>
                            </div>
                          )}
                          {(orderType !== "cancelOrder" && orderType !== "allOrder" && orderType !== "completeOrder") ? (
                            <>
                              {(deliveableFlag && orderType !== 'openOrder') ? (
                                <>
                                  {items.userType !== "BUYER" && orderType !== "claimOrder" ? (
                                    <div>
                                      <p onClick={() => {
                                        setSelectedItem(items);
                                        toggleBOLModal();
                                      }}>
                                        Re-Upload BOL
                                      </p>
                                    </div>
                                  ) : (
                                    <h6></h6>
                                  )}
                                  <div>
                                    <p onClick={() => {
                                      if (items.fileBOL) {
                                        imageUpload(items.fileBOL);
                                      } else {
                                        setModalContent('Please upload BOL first.');
                                        setModalLink("");
                                        toggleModal();
                                      }
                                    }}>
                                      {items.userType === "BUYER"
                                        ? "Print POD" : "Print BOL/POD"}
                                    </p>
                                  </div>
                                </>
                              ) : (
                                <div></div>
                              )}
                            </>
                          ) : (
                            <div></div>
                          )}
                        </PrintContainer>
                      </div>
                    </div>
                  </AccordionDetails>
                </Accordion>
              </div>
            );
          })}
        </>
      ) : (
        <NoRecordFound>
          {pageLanguageContents?.DetailedContents[3]?.NoRecord}
        </NoRecordFound>
      )}

      {onHoldModal && paymentResponse && (
        <OnHoldModal
          isOpen={onHoldModal}
          toggle={toggleOnHoldModal}
          content=""
          response={paymentResponse}
          link=""
          orderRetryPayment='Exclude_Ach'
          onHoldCallBack={(paymentMethodId) => {
            toggleOnHoldModal();
            openOrderCallBack(oredrId, paymentMethodId);
          }}
        />
      )}
      <AlertModal
        isOpen={modal}
        toggle={toggleModal}
        title={title}
        content={modalContent}
        link={modalLink}
        alertType={alertType}
        callBackAlert={(val) => {
          if (val === "success") {
            deliveredOrderCallBack()
          }
        }}
      />
      {claimRaiseId && (
        <ClaimRaisePopup
          isOpen={claimRaiseModal}
          toggle={claimRaiseToggleModal}
          title=""
          onClickHander={(obj) => { }}
          content=""
          link="/"
          claimRaiseId={claimRaiseId}
        />
      )}
      <BolUploadModal
        isOpen={modalBOL}
        toggle={toggleBOLModal}
        title={""}
        content={modalBOLContent}
        link={modalBOLLink}
        callBackBOL={(document) => {
          if (modalBOLType === 'upload') {
            if (orderType === 'allOrder') allOrderShipDeliverCallback(selectedItem.id, "DELIVERED", document)
            else callBackFun(selectedItem.id, "DELIVERED", document);
          } else {
            callUpdateBOL("DELIVERED", document);
          }
        }}
        uploadType={modalBOLType === 'upload' ? 'upload' : "reUpload"}
        selectedItem={selectedItem}
      />
      {cancelOrderId && (
        <CancelOrderPopup
          isOpen={cancelOrderModal}
          toggle={cancelOrderToggleModal}
          title=""
          onClickHander={(obj) => { }}
          content=""
          link="/"
          cancelOrderId={cancelOrderId}
          items={itemState}
          requestType={requestType}
          modalCallBackFun={(id, action, props, comment) => {
            modalCallBack(id, action, props, comment);
          }}
        />
      )}
    </>
  );
};

export default OrderBox;

const FirstSction = styled.div`
  flex: 1 1;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  grid-gap: 0 20px;
  gap: 0 10px;
  color: #191819;
  .mobile-view-status {
    display: none;
  }
  .po-number-tag {
    display: inline-block;
  }

  h6 {
    word-break: break-word;
    color: #0a5587;
    min-width: 160px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 20px;
    max-width: 145px;
    width: 100%;
  }
  @media (max-width: 800px) {
    .po-number-tag {
      display: none;
    }
  }
  @media (max-width: 550px) {
    .heading-with-status {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
    }
    .mobile-view-status {
      display: inline-flex;
    }

    h6 {
      min-width: auto !important;
    }
    p {
      min-width: auto !important;
    }
  }
`;
const SecondSction = styled.div`
  grid-gap: 6px;
  gap: 60px;
  display: flex;
  align-items: center;
  .status-min-width{
    min-width: 110px;
  }
  .web-view-status {
    display: inline-flex;
  }
  @media (max-width: 550px) {
    .web-view-status {
      display: none;
    }
  }
`;
const NoRecordFound = styled.div`
  text-align: center;
  padding-top: 2%;
  padding-bottom: 4%;
  background: white;
`;
const InfoText = styled.span`
  width: 13px;
  display: inline-block;
  vertical-align: text-bottom;
  margin-left: 4px;
  cursor: pointer;
  img {
    max-width: 100%;
  }
`;


const StatusWrapper = styled.div`
  span {
    font-size: 15px;
    border-radius: 5px;
    padding: 2px 10px;
    min-width: 90px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    font-family: 'latobold';
    background: none;
    background-color: transparent !important;
  }
  .greenStatus{
    color: #68a107;
  }
  .redStatusColour{
    color: red;
  }
  .blackStatus{
    color: black;
  }
  .yellowStatus{
    color: orange;
  }
`;

const QuickButtonWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  min-width: 205px;
  justify-content: center;
  .darkBlueBg{
    background: linear-gradient(180deg, #0A5587 0%, #12659D 100%);
    color: #fff;
    font-size: 12px;
    border-radius: 5px;
    padding: 2px 10px;
    display: inline-flex;
    width: 100px;
    height: 36px;
    align-items: center;
    justify-content: center;
  }
  .blueBg{
    background: linear-gradient(180deg, #0A5587 0%, #12659D 100%);
    color: #fff;
    font-size: 12px;
    border-radius: 5px;
    padding: 2px 10px;
    display: inline-flex;
    width: 100px;
    height: 36px;
    margin-left: 10px;
    align-items: center;
    justify-content: center;
    span{
      background: #68a107;
      color: #fff;
      width: 23px;
      height: 23px;
      border-radius: 50%;
      font-size: 12px;
      text-align: center;
      z-index: 1;
      position: absolute;
      bottom: 26px;
      right: -10px;
      padding: 2px;
    }
  }
  .cancelBg{
    width: 210px;
    justify-content: center;
    display: flex;
  }
`;

const OpenOrderMain = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
`;
